export default function LeafIcon() {
  return (
    <svg width="60" height="30" viewBox="0 0 60 30" fill="none" className="my-6 block">
      <path d="M5 25C15 20 25 15 30 10C35 5 45 2 55 5" stroke="oklch(var(--accent-400))" strokeWidth="1.5" fill="none" />
      <path d="M30 10C25 8 20 12 18 18" stroke="oklch(var(--accent-400))" strokeWidth="1" fill="none" />
      <path d="M30 10C35 8 40 12 42 18" stroke="oklch(var(--accent-400))" strokeWidth="1" fill="none" />
    </svg>
  );
}